// import React, { Component } from 'react'
// import Link from 'gatsby-link'
// import MediaQuery from 'react-responsive'
// import Img from 'gatsby-image'

// //Components
// import SelectLanguage from './SelectLanguage.js'

// //Menus
// import MainNav from '../menus/MainNav.js'
// import SecondNav from '../menus/SecondNav.js'

// class Header extends Component {
//   constructor(props) {
//     super(props)
//     this.state = {
//       mobile_toogle: false,
//     }
//     this.handleMobileToggle = this.handleMobileToggle.bind(this)
//   }
//   handleMobileToggle() {
//     const mobile_toogle = !this.state.mobile_toogle
//     this.setState({
//       mobile_toogle,
//     })
//   }
//   render() {
//     const menuToggle = this.state.mobile_toogle ? 'show' : 'hidden'
//     const langPrefix = () => {
//       return this.props.langs.find(lang => lang.selected).langKey
//     }
//     return (
//       <React.Fragment>
//         <MediaQuery query="(max-width: 769px)">
//           <header>
//             <div className="logo">
//               <Link to={`/${langPrefix()}`}>
//                 <Img
//                   title="Budget"
//                   alt="Budget Nicaragua"
//                   sizes={this.props.headerLogo.sizes}
//                 />
//               </Link>
//             </div>
//             <div className="menu-toogle">
//               <a
//                 id="nav-toggle"
//                 href="#"
//                 onClick={this.handleMobileToggle}
//                 className={menuToggle}
//               >
//                 Menu
//               </a>
//             </div>
//           </header>
//           <div className={`menu-wrapper ${menuToggle}`}>
//             <MainNav
//               langs={this.props.langs}
//               toogle={this.handleMobileToggle}
//               toogleClass={this.state.mobile_toogle}
//             />
//             <SecondNav
//               langs={this.props.langs}
//               toogle={this.handleMobileToggle}
//             />
//           </div>
//         </MediaQuery>

//         <MediaQuery query="(min-device-width: 769px)">
//           <header>
//             <div className="container">
//               <SecondNav langs={this.props.langs} />
//               <div className="main">
//                 <div className="logo">
//                   <Link to={`/${langPrefix()}`} className="logo">
//                     <Img
//                       title="Budget"
//                       alt="Budget logo"
//                       sizes={this.props.headerLogo.sizes}
//                     />
//                   </Link>
//                 </div>
//                 <MainNav langs={this.props.langs} />
//               </div>
//             </div>
//           </header>
//         </MediaQuery>
//       </React.Fragment>
//     )
//   }
// }

// export default Header



import React, { Component } from 'react'
import Link from 'gatsby-link'
import MediaQuery from 'react-responsive'
import Img from 'gatsby-image'

//Components
import SelectLanguage from './SelectLanguage.js'

//Menus
import MainNav from '../menus/MainNav.js'
import SecondNav from '../menus/SecondNav.js'

class Header extends Component {
  constructor(props) {
    super(props)
    this.state = {
      mobile_toogle: false,
    }
    this.handleMobileToggle = this.handleMobileToggle.bind(this)
  }
  handleMobileToggle() {
    const mobile_toogle = !this.state.mobile_toogle
    this.setState({
      mobile_toogle,
    })
  }
  render() {
    const menuToggle = this.state.mobile_toogle ? 'show' : 'hidden'
    const langPrefix = () => {
      return this.props.langs.find(lang => lang.selected).langKey
    }
    return (
      <React.Fragment>
        <MediaQuery query="(max-width: 769px)">
          <header>
            <div className="logo">
              <Link to={`/${langPrefix()}`}>
                <Img
                  title="Budget"
                  alt="Budget Guatemala"
                  sizes={this.props.headerLogo.sizes}
                />
              </Link>
            </div>
            <div className="menu-toogle"></div>

            <div>
              <a
                id="nav-toggle"
                href="#"
                onClick={this.handleMobileToggle}
                className={menuToggle}
              >
               <div style={{width: '35px', height: '5px', backgroundColor: '#E55720', margin: '6px 0' , borderRadius: '3px'}}></div>
               <div style={{width: '35px', height: '5px', backgroundColor: '#E55720', margin: '6px 0' , borderRadius: '3px'}}></div>
               <div style={{width: '35px', height: '5px', backgroundColor: '#E55720', margin: '6px 0' , borderRadius: '3px'}}></div> 



              </a>
            </div>
          </header>
          <div className={`menu-wrapper ${menuToggle}`}>
            <MainNav
              langs={this.props.langs}
              toogle={this.handleMobileToggle}
              toogleClass={this.state.mobile_toogle}
            />
            <SecondNav
              langs={this.props.langs}
              toogle={this.handleMobileToggle}
            />
          </div>
        </MediaQuery>

        <MediaQuery query="(min-device-width: 769px)">
          <header>
            <div className="container">
              <SecondNav langs={this.props.langs} />
              <div className="main">
                <div className="logo">
                  <Link to={`/${langPrefix()}`} className="logo">
                    <Img
                      title="Budget"
                      alt="Budget logo"
                      sizes={this.props.headerLogo.sizes}
                    />
                  </Link>
                </div>
                <MainNav langs={this.props.langs} />
              </div>
            </div>
          </header>
        </MediaQuery>
      </React.Fragment>
    )
  }
}

export default Header



// WEBPACK FOOTER //
// ./src/components/Header.js